import MarkAsReadOptionState from '../store/schema/MarkAsReadOptionState';
import store from '../store/store';
import MarkAsRead from 'owa-service/lib/contract/MarkAsRead';
import { action, select } from 'satcheljs/lib/legacy';

export type MarkAsReadChoiceKey = 'Instant' | MarkAsRead;

export interface SelectMarkAsReadOptionState {
    optionState: MarkAsReadOptionState;
}

export default select<SelectMarkAsReadOptionState>({
    optionState: () => store,
})(
    action('selectMarkAsReadOption')(function selectMarkAsReadOption(
        choice: MarkAsReadChoiceKey,
        state?: SelectMarkAsReadOptionState
    ) {
        let { optionState } = state;
        optionState.behavior = choice === 'Instant' ? 'Delayed' : choice;
        // TODO: VSO:13206 - Implement a customizable delay
        optionState.delay = choice === 'Instant' ? 0 : 5;
    })
);
